module.exports = __webpack_public_path__ + "static/media/summary-look.e7e64a26.svg";